import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// Components

import Form from '@lib/wrappers/Form';
import UniversalInput from '@lib/wrappers/UniversalInput';

// ActionCreators

import { changeData } from '@actions/ssap/ssapActionCreators';

// Utils

import { removeProtocol } from '@utils/miscellaneous/removeProtocol';

// Constants

import EXTERNAL_LINKS from '@constants/configs/externalEndpoints';
import { configs } from '@constants/configs/configs';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';


/**
 *
 * @param {Object} props
 * @returns {React.Component} - 'Privacy of Your Information' Page
 *
 */
const Page1_00 = props => {

    const {
        data,
        data: {
            acceptPrivacyIndicator
        },
        environment: {
            exchangeName,
            links: {
                PRIVACY_POLICY
            },
            stateCode
        },
        formName
    } = props;

    /**
     *
     * @param {Object} newData - updated <singleStreamlinedApplication> object
     *
     * Updating <acceptPrivacyIndicator> props in JSON
     */
    const onFieldChange = newData => {
        props.actions.changeData({
            ...newData
        });
    };

    return (
        <Fragment>
            <div id="saPrivacyInfo" className="fade-in">
                <div className="subsection">
                    <h3 className="header gi-heading-alt">
                        <FormattedMessage
                            id="ssap.start.before_we_begin.page_header"
                        />
                    </h3>
                    <p>
                        <FormattedMessage id="ssap.start.before_we_begin.privacy_notification" values={{ lineBreak: <br /> }} />
                    </p>
                    {
                        configs.states.NEW_JERSEY === stateCode ?
                            <FormattedMessage id="ssap.start.before_we_begin.we_will_not_ask"/> :
                            null
                    }
                    <h4 className="margin-y-2 gi-heading-alt">
                        <FormattedMessage
                            id="ssap.start.before_we_begin.important_header"
                        />
                    </h4>
                    <p>
                        <FormattedMessage
                            id="ssap.start.before_we_begin.retrieving_data_notification"
                            values={ { exchangeName } }
                        />
                    </p>
                    {
                        configs.states.NEW_JERSEY === stateCode ?
                            <Fragment>
                                <FormattedMessage id="ssap.start.before_we_begin.retrieving_also_communicate" tagName='p'/>
                                <FormattedMessage id="ssap.start.before_we_begin.retrieving_data_information" tagName='p'/>
                            </Fragment>
                            :
                            null
                    }

                    <p> 
                        <FormattedMessage
                            id="ssap.start.before_we_begin.link_to_notices_practices"
                            values={{
                                link:(
                                    <a
                                        className="usa-link--external"
                                        href={PRIVACY_POLICY}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FormattedMessage id="ssap.start.before_we_begin.link_text"/>
                                    </a>
                                )
                            }}
                        />
                    </p>
                    {
                        configs.states.NEW_JERSEY === stateCode ?
                            <FormattedMessage
                                id="ssap.start.before_we_begin.i_have_reviewed"
                                values={ {
                                    link_one: (
                                        <a
                                            className="usa-link--external"
                                            href = { EXTERNAL_LINKS.NJ_LINKS.GET_COVERED }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            { removeProtocol(EXTERNAL_LINKS.NJ_LINKS.GET_COVERED) }
                                        </a>
                                    ),
                                    link_two: (
                                        <a
                                            className="usa-link--external"
                                            href = { EXTERNAL_LINKS.NJ_LINKS.FAMILY_CARE }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            { removeProtocol(EXTERNAL_LINKS.NJ_LINKS.FAMILY_CARE) }
                                        </a>
                                    )
                                } }
                            /> :
                            null
                    }
                </div>
                <div className="subsection">
                    <Form className="usa-form" { ...{ formName } }>
                        <UniversalInput
                            label={{
                                text: 'ssap.input.label.before_we_begin.agreement',
                                labelClass: ['required-true']
                            }}
                            inputData={{
                                isInputRequired: true,
                                classes:[''],
                                type: INPUT_TYPES.CHECKBOX,
                                name: 'acceptPrivacyIndicator',
                                checked: acceptPrivacyIndicator,
                                value: acceptPrivacyIndicator,
                                validationType: VALIDATION_TYPES.CHECKED,
                                currentData: data,
                                fields: []
                            }}
                            inputActions={{
                                onFieldChange
                            }}
                            errorClasses={['margin-l-0']}
                        />
                    </Form>
                </div>
            </div>
        </Fragment>
    );
};


const mapStateToProps = state => ({
    environment: state.common.environment,

    data: state.ssap.data,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeData
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Page1_00);
